export const numericBreakpoints = {
  XS: 575,
  S: 767,
  M: 991,
  L: 1200,
};

export default {
  XS: `${numericBreakpoints.XS}px`,
  S: `${numericBreakpoints.S}px`,
  M: `${numericBreakpoints.M}px`,
  L: `${numericBreakpoints.L}px`,
};
